import { render, staticRenderFns } from "./EditFormLesiones.vue?vue&type=template&id=5cf3278e"
import script from "./EditFormLesiones.vue?vue&type=script&lang=js"
export * from "./EditFormLesiones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports